<template>
  <div class="content">
    <div class="content-left">
      <div class="conl-top">
        <img src="../../assets/img/logo.png" />
        <div :style="barsid ? 'width:0;' : 'transition: all 0.3s;'">
          刘湾零工市场
        </div>
      </div>
      <div class="conl-other">
        <el-menu :router="true" class="el-menu-vertical-demo" :collapse="barsid" :default-active="active"
          :unique-opened="true" background-color="#182B5C" text-color="#dddddd" active-text-color="#ffffff"
          @open="handleOpen" @close="handleClose">
          <template v-for="(item, index) in authority">
            <el-menu-item v-bind:key="index" :index="item.path" v-if="!item.no && !item.children">
              <img src="../../assets/img/icon1.png" class="title-img" v-if="index == 0" />
              <img src="../../assets/img/icon2.png" class="title-img" v-if="index == 1" />
              <img src="../../assets/img/icon3.png" class="title-img" v-if="index == 2" />
              <img src="../../assets/img/icon4.png" class="title-img" v-if="index == 3" />
              <img src="../../assets/img/icon5.png" class="title-img" v-if="index == 4" />
              <img src="../../assets/img/icon6.png" class="title-img" v-if="index == 5" />
              <img src="../../assets/img/icon6.png" class="title-img" v-if="index == 6" />
              <img src="../../assets/img/icon7.png" class="title-img" v-if="index == 7" />
              <span class="title-name">{{ item.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      isclose: false,
      active: "0",
      flag: true,
      authority: [], // 菜单
    };
  },
  mounted() {
    var href = window.location.href;
    var str = href.substring(href.lastIndexOf("/"), href.length);
    this.active = str;
    // this.init()
    this.authority = [
      { path: "/", title: "职位管理", img: "../../assets/img/icon1.png" },
      { path: "/positionRecruitCenter", title: "招募人员岗位管理", img: "../../assets/img/icon1.png" },
      { path: "/recommend", title: "推荐/搜索", img: "../../assets/img/icon2.png" },
      { path: "/communicate", title: "沟通", img: "../../assets/img/icon3.png" },
      { path: "/recruiting", title: "招聘管理", img: "../../assets/img/icon4.png" },
      { path: "/projectOutsourcing", title: "项目外包", img: "../../assets/img/icon5.png" },
      { path: "/recruitmentData", title: "招聘数据", img: "../../assets/img/icon6.png" },
      { path: "/gasStation", title: "企业加油站", img: "../../assets/img/icon6.png" },
      { path: "/personalCenter", title: "个人中心", img: "../../assets/img/icon7.png" },
    ];
    // this.active = this.$route.path;
    let index = this.$route.path.indexOf("Detail");
    this.active =
      index > -1 ? this.$route.path.substring(0, index) : this.$route.path;
  },
  watch: {
    $route(to, from) {
      
      let index = to.path.indexOf("Detail");
      this.active = index > -1 ? to.path.substring(0, index) : to.path;
    },
  },
  computed: {
    barsid() {
      return this.$root.barflag;
    },
  },
  //方法
  methods: {
    init() {
      this.$getRequest("/getRouters", {}).then((res) => {
        if (res.code == 200) {
          this.authority = res.data;
        }
      });
    },
    handleOpen(key, keyPath) { },
    handleClose(key, keyPath) { },
  },
};
</script>
<style scoped>
.content {
  width: 100%;
  height: 100%;
  background: #1f2128;
}

.content-left {
  height: 100%;
}

.conl-top {
  width: 100%;
  height: 50px;
  background: #22459f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  overflow: hidden;
}

.conl-top>img {
  width: 40px;
  height: 40px;
  /* padding-top: 19px; */
  /* margin-right: 8px; */
  display: block;
}

.conl-top>div {
  width: 100px;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
}

.conl-other {
  height: calc(100% - 50px);
  background: #182b5c;
}

.conl-other ::v-deep .el-submenu__title {
  padding-left: 14px !important;
}

.title-img {
  width: 18px;
  height: 18px;
}

.title-name {
  font-size: 16px;
}

.conl-other>.el-menu {
  border: none !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  /* width: 200px !important; */
}

.el-menu-item.is-active {
  background-color: #203b82 !important;
}
.el-menu-item {
  padding: 0 20px !important;
}

.conl-other ::v-deep .el-menu-item:hover {
  background-color: #203b82 !important;
}

::v-deep .title {
  display: flex !important;
  justify-content: center !important;
  padding: 0 !important;
}

.i_0 {
  width: 30px;
  height: 30px;
  margin-right: 7px;
  object-fit: cover;
}

.i_1 {
  display: inline-block;
  margin-right: 7px;
  margin-top: -4px;
}

.i_2 {
  display: inline-block;
  margin-right: 7px;
  /* line-height: 30px; */
  margin-top: -4px;
}

.el_1 {
  padding-left: 50px !important;
}

::v-deep .huaban .el-submenu__title .el-submenu__icon-arrow::before {
  display: none !important;
}
</style>